let mapModulePromise = null;

function loadShowroomMapModule() {
    if (!mapModulePromise) {
        mapModulePromise = import(
            /* webpackChunkName: "showroom-map" */
            './showroom-map'
        );
    }

    return mapModulePromise;
}

function createAppointmentCardHandler(card) {
    const handler = {
        elements: {
            locationItems: card.querySelectorAll('.js-location-item'),
            locationsContainer: card.querySelector('.c-appointment-card__locations'),
            locationsContent: card.querySelector('.c-appointment-card__locations-content'),
            iframeView: card.querySelector('.c-appointment-card__iframe-view'),
            iframeContainer: card.querySelector('.c-appointment-card__iframe-container'),
            backButton: card.querySelector('.js-iframe-back'),
            modalTriggers: card.querySelectorAll('.c-appointment-card__description-wrapper'),
            subjectHeader: card.querySelector('.c-appointment-card .c-subject-header'),
        },
        state: {
            isAnimating: false,
            isIframeViewActive: false,
        },
        config: {
            fadeOutDuration: 300,
            fadeInDelay: 50,
        },

        init() {
            if (!this.validateElements()) {
                return;
            }

            this.bindEvents();
        },

        validateElements() {
            const { locationsContainer, iframeView, iframeContainer } = this.elements;
            return !!(locationsContainer && iframeView && iframeContainer);
        },

        bindEvents() {
            this.bindLocationItemClicks();
            this.bindBackButtonClick();
        },

        bindLocationItemClicks() {
            this.elements.locationItems.forEach((item) => {
                item.addEventListener('click', (e) => this.handleLocationItemClick(e, item));
            });
        },

        handleLocationItemClick(e, item) {
            e.preventDefault();

            const bookingUrl = item.dataset.bookingUrl;
            if (!bookingUrl) {
                return;
            }

            this.showBookingEmbed(bookingUrl);
        },

        bindBackButtonClick() {
            if (!this.elements.backButton) {
                return;
            }

            this.elements.backButton.addEventListener('click', (e) => this.handleBackButtonClick(e));
        },

        handleBackButtonClick(e) {
            e.preventDefault();
            this.hideIframeView();
        },

        showBookingEmbed(bookingUrl) {
            if (this.state.isAnimating || this.state.isIframeViewActive) {
                return;
            }

            this.state.isAnimating = true;
            this.elements.iframeContainer.innerHTML = '';

            this.fadeOutLocations(() => {
                this.displayIframeView();

                if (window.Bookings && window.Bookings.inlineEmbed) {
                    window.Bookings.inlineEmbed({
                        url: bookingUrl,
                        parent: `#${this.elements.iframeContainer.id}`,
                        height: '600px',
                    });
                }

                this.fadeInIframeView();
            });
        },

        fadeOutLocations(callback) {
            this.elements.locationsContainer.classList.add('fade-out');

            setTimeout(() => {
                this.elements.locationsContainer.style.display = 'none';
                this.elements.locationsContainer.classList.remove('fade-out');
                callback();
            }, this.config.fadeOutDuration);
        },

        displayIframeView() {
            this.elements.iframeView.style.display = 'block';

            if (!this.elements?.backButton) {
                return;
            }

            this.elements.backButton.style.display = 'flex';
            this.hideModalTriggers();
        },

        fadeInIframeView() {
            setTimeout(() => {
                this.elements.iframeView.classList.add('fade-in');
                if (this.elements?.backButton) {
                    this.elements.backButton.classList.add('fade-in');
                }
                this.state.isIframeViewActive = true;
                this.state.isAnimating = false;
            }, this.config.fadeInDelay);
        },

        hideIframeView() {
            if (this.state.isAnimating || !this.state.isIframeViewActive) {
                return;
            }

            this.state.isAnimating = true;

            this.fadeOutIframeView(() => {
                this.hideIframeElements();
                this.displayLocations();
                this.fadeInLocations();
            });
        },

        fadeOutIframeView(callback) {
            this.elements.iframeView.classList.remove('fade-in');
            if (this.elements?.backButton) {
                this.elements.backButton.classList.remove('fade-in');
            }

            setTimeout(callback, this.config.fadeOutDuration);
        },

        hideIframeElements() {
            this.elements.iframeView.style.display = 'none';
            if (this.elements?.backButton) {
                this.elements.backButton.style.display = 'none';
            }
            this.elements.iframeContainer.innerHTML = '';
            this.showModalTriggers();
        },

        displayLocations() {
            this.elements.locationsContainer.style.display = 'block';
        },

        fadeInLocations() {
            setTimeout(() => {
                this.elements.locationsContainer.classList.add('fade-in');
                this.state.isIframeViewActive = false;
                this.state.isAnimating = false;

                setTimeout(() => {
                    this.elements.locationsContainer.classList.remove('fade-in');
                }, this.config.fadeOutDuration);
            }, this.config.fadeInDelay);
        },

        hideModalTriggers() {
            if (!this.elements?.modalTriggers) {
                return;
            }

            this.elements.modalTriggers.forEach((btn) => {
                btn.style.display = 'none';
            });
            this.elements.subjectHeader.classList.add('c-subject-header--remove-line');
        },

        showModalTriggers() {
            if (!this.elements?.modalTriggers) {
                return;
            }

            this.elements.modalTriggers.forEach((btn) => {
                btn.style.removeProperty('display');
            });
            this.elements.subjectHeader.classList.remove('c-subject-header--remove-line');
        },
    };

    handler.init();
}

function hasShowroomMap(card) {
    return !!(card.querySelector('.js-showroom-map') || card.querySelector('#map'));
}

function setMapLoadingState(card, isLoading) {
    const mapElement = card.querySelector('.js-showroom-map') || card.querySelector('#map');
    if (!mapElement) {
        return;
    }

    mapElement.classList.toggle('is-loading', isLoading);
}

async function openLocationsModal(card) {
    const modal = card.querySelector('.c-modal');
    if (!modal) {
        return;
    }

    modal.classList.add('isActive');
    document.body.classList.add('no-scroll');

    if (!hasShowroomMap(card)) {
        return;
    }

    setMapLoadingState(card, true);

    try {
        const { initShowroomMap, resizeShowroomMap } = await loadShowroomMapModule();
        initShowroomMap(card);
        resizeShowroomMap(card);
    } finally {
        setMapLoadingState(card, false);
    }
}

function bindModalHandlers(card) {
    card.querySelectorAll('.js-modal-trigger').forEach(function (openModal) {
        openModal.addEventListener('click', () => {
            openLocationsModal(card);
        });
    });

    card.querySelectorAll('.js-modal-close').forEach(function (closeModal) {
        closeModal.addEventListener('click', () => {
            const modal = card.querySelector('.c-modal');
            modal?.classList.remove('isActive');
            document.body.classList.remove('no-scroll');
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-appointment-card').forEach(function (card) {
        createAppointmentCardHandler(card);
        bindModalHandlers(card);
    });
});
